<script setup lang="ts">
import PartFooterNavigation from '@parts/part-footer-navigation.vue';
import PartTitleHead from '@parts/part-title-head.vue';
import PartOutisdeLinks from '@parts/part-outisde-links.vue';
import SectionSettings from '@sections/section-settings.vue';
import ButtonPrimary from '@buttons/button-primary.vue';

import {useI18n} from 'vue-i18n';
import {useSettings} from '@composables/settings';
import {computed, onBeforeMount, ref} from 'vue';
import CoreLoader from "@core/core-loader.vue";
import {useSettingsApi} from "@store/api/settingsApi";
import {AppInfo} from "@store/api/interfaces";

const {t} = useI18n();
const {
  goToNext,
  goToBack,
  activeIndex,
  currentGroup,
  checkCurrentPageAccess,
} = useSettings();

const settingsApi = useSettingsApi();
const isLoading = ref<boolean>(false);
const loaderText = ref<string>(t('common.loader.default'));
const listApps = ref<AppInfo[]>([]);

const fields = computed(() => {
  return {
    title: t('downloadApp.title'),
    list: listApps.value
        .map(app => app.download_link ? {
          url: app.instruction_link,
          title: app.platform_name,
          label: app.name,
          target: "_blank"
        } : null)
        .filter((item) => item !== null),
    buttonNext: {
      title: t('common.buttons.installed'),
    },
    buttonBack: {
      title: t('common.buttons.back'),
    },
  }
});

onBeforeMount(async () => {
  isLoading.value = true;
  listApps.value = await settingsApi.getApps();
  isLoading.value = false;
});

checkCurrentPageAccess();
</script>

<template>
  <main class="page page-os">
    <section-settings
        v-if="currentGroup"
    >
      <transition
          appear
          name="fade"
          style="--animation-delay: 0.1s"
      >
        <part-title-head
            v-if="fields.title"
            :title="fields.title"
            title-font="font-18-pro-medium"
            sub-title-font="font-regular"
            class="page-os__content"
        ></part-title-head>
      </transition>

      <!--
        Для <transition> нужно задать продолжительность анимации: animation-delay.
        Через "--animation-count" передаем количество элементов в списке, для построения продолжительсности.
      -->
      <transition
          v-if="!isLoading"
          appear
          name="show-up-container-items"
          :style="`--animation-item-delay: 0.2s;
				--animation-duration: 0.6s;
				--animation-count: ${listApps.length || 0}`"
      >
        <part-outisde-links
            :list="fields.list"
            :icon="{name: 'align-bottom', viewBox: '0 0 16 16'}"
            class="page-os__list"
        >
        </part-outisde-links>
      </transition>
      <transition
          v-else
          appear
          name="show-up-container-items"
          :style="`--animation-delay: 0.3s;
				--animation-item-delay: 0.2s;
				--animation-duration: 0.6s;`"
      >
        <core-loader
            dark
            inline
            :title="loaderText"
        />
      </transition>


      <part-footer-navigation
          v-if="activeIndex + 1 !== currentGroup?.list?.length"
          class="page-os__footer"
      >
        <button-primary

            @click.native="goToNext"
            class="page-os__save"
        >
          {{ fields?.buttonNext?.title }}
        </button-primary>
      </part-footer-navigation>
      <button-primary
          v-else
          pink
          @click.native="goToBack"
          class="page-os__save"
      >
        {{ fields?.buttonBack?.title }}
      </button-primary>
    </section-settings>
  </main>
</template>

<style lang="scss">
// TODO: change class name
.page-os {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  &__content {
    --title-gap: 1.6rem;
    margin-bottom: 2.4rem;
  }

  &__list {
    margin-bottom: 2rem;
	@include min-desktop {
		margin-bottom: 6.4rem;
	}
  }

  &__save {
    width: 100%;
    margin-top: auto;
  }
}
</style>
